import pick from 'lodash/pick'

export type UpdateTeamPayload = {
  two_factor_auth_enforced?: boolean
  sso_enforced?: boolean
  annotators_can_create_tags_and_attributes?: boolean
  restrict_exports?: boolean
  export_token_ttl?: number | null
  default_role?: string
  email_domain?: string

  content?: Blob
  hash?: string
  name?: string
  type?: string
}

export type UpdateTeamErrorResponse = {
  emailDomain?: string
  name?: string
  ssoAuthEnforced?: string
}

export const createUpdateTeamError = (error: unknown): UpdateTeamErrorResponse => {
  if (typeof error !== 'object' || error === null) {
    throw new Error('Unknown error while updating team')
  }
  if ('name' in error && typeof error.name !== 'string') {
    throw new Error('Unknown error while updating team')
  }
  if ('emailDomain' in error && typeof error.emailDomain !== 'string') {
    throw new Error('Unknown error while updating team')
  }
  if ('ssoAuthEnforced' in error && typeof error.ssoAuthEnforced !== 'string') {
    throw new Error('Unknown error while updating team')
  }
  return pick(error, ['name', 'emailDomain', 'ssoAuthEnforced']) as UpdateTeamErrorResponse
}
